<template>
    <div class="change-password">
        <el-form :model="passwordForm" :rules="rules" ref="passwordForm" label-width="120px" size="small">
            <el-form-item label="旧密码" prop="oldPassword">
                <el-input 
                    v-model="passwordForm.oldPassword" 
                    type="password" 
                    autocomplete="off" 
                    placeholder="请输入旧密码"
                    show-password>
                </el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
                <el-input 
                    v-model="passwordForm.newPassword" 
                    type="password" 
                    autocomplete="off" 
                    placeholder="请输入新密码"
                    show-password>
                </el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="confirmPassword">
                <el-input 
                    v-model="passwordForm.confirmPassword" 
                    type="password" 
                    autocomplete="off" 
                    placeholder="请再次输入新密码"
                    show-password>
                </el-input>
            </el-form-item>
        </el-form>
        <div class="btn-group">
            <el-button type="primary" @click="onSubmit()" :loading="loading" size="large">提 交</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "changePassword",
    data() {
        // 自定义验证规则：确认密码必须与新密码一致
        const validateConfirmPassword = (rule, value, callback) => {
            if (value !== this.passwordForm.newPassword) {
                callback(new Error('两次输入的密码不一致'));
            } else {
                callback();
            }
        };
        
        return {
            loading: false,
            passwordForm: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            rules: {
                oldPassword: [
                    { required: true, message: '请输入旧密码', trigger: 'blur' }
                ],
                newPassword: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '请再次输入新密码', trigger: 'blur' },
                    { validator: validateConfirmPassword, trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        init() {
            // 重置表单
            this.passwordForm = {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            };
            // 清除表单验证状态
            if (this.$refs.passwordForm) {
                this.$refs.passwordForm.clearValidate();
            }
        },
        onSubmit() {
            this.$refs.passwordForm.validate((valid) => {
                if (!valid) {
                    return false;
                }
                
                this.loading = true;
                this.$http({
                    url: "/modifyPwd",
                    method: "put",
                    data: {
                        oldPassword: this.passwordForm.oldPassword,
                        newPassword: this.passwordForm.newPassword,
                        confirmPassword: this.passwordForm.confirmPassword
                    }
                }).then(() => {
                    this.$message.success("密码修改成功");
                    // 重置表单
                    this.init();
                }).catch((error) => {
                    // 错误处理已在 httpRequest 中统一处理
                    console.error('修改密码失败:', error);
                }).finally(() => {
                    this.loading = false;
                });
            });
        }
    }
}
</script>

<style scoped lang="scss">
.change-password {
    padding: 20px;
    
    .btn-group {
        text-align: center;
        margin-top: 30px;
    }
}
</style>

